import React from 'react';
import Image from '../../../../components/AppImage';

export const renderPartnerLogo = (partner) => {
  if (!partner.logo || partner.logo === "") {
    return null;
  }

  const heightClass = partner.className || (partner.isLarge ? 'max-h-40' : 'max-h-32');

  const logoElement = (
    <Image
      src={partner.logo}
      alt={partner.logoAlt || partner.name}
      className={`${heightClass} w-auto object-contain transition-transform duration-300 hover:scale-110 cursor-pointer`}
      style={partner.isBlack ? { filter: 'brightness(0)' } : {}}
    />
  );

  if (partner.website) {
    return (
      <a
        href={partner.website}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Visit ${partner.name} website`}
        className="block"
      >
        {logoElement}
      </a>
    );
  }
  return logoElement;
};

export const partnersContent = {
  ar: {
    whoAreWeTitle: "من نحن",
    organizersTitle: "المنظمين",
    sponsorsTitle: "الرعاة",
    strategicSponsorTitle: "الراعي الاستراتيجي",
    diamondSponsorTitle: "الراعي الماسي",
    goldSponsorTitle: "الراعي الذهبي",
    silverSponsorTitle: "الراعي الفضي",
    technicalSponsorTitle: "الراعي الفني",
    technicalPartnerTitle: "الراعي التقني",
    culturalSponsorTitle: "الراعي الثقافي",
    financialSponsorTitle: "الراعي",
    successPartnersTitle: "شركاء النجاح",
    eventPartnersTitle: "شركاء الحفل",
    partnersOfTheDayTitle: "شركاء هذا اليوم",
    partnersOfTheDayDescription: "بفضل الجهات التي اختارت أن تكون جزءًا من هذا العمل، يكتمل الحفل ويقوى أثره. هنا تجد الجهات المساهمة في تنظيم فعاليات “عام النصر” في مختلف الولايات.",
    becomePartnerTitle: "كن شريكًا معنا في هذا اليوم",
    becomePartnerSubtitle: "ساهم في إنجاح فعالية \"عام على النصر\" عبر عرض إمكانيات مؤسستك، سواء في فعالية إسطنبول الرئيسية أو في أي ولاية أخرى نقيم فيها الحفل.",
    becomePartnerButton: "قدّم طلب شراكة عبر التواصل على واتساب عبر الرقم التالي"
  },
  en: {
    whoAreWeTitle: "Who are we",
    organizersTitle: "Organizers",
    sponsorsTitle: "Sponsors",
    strategicSponsorTitle: "Strategic Sponsor",
    diamondSponsorTitle: "Diamond Sponsor",
    goldSponsorTitle: "Gold Sponsor",
    silverSponsorTitle: "Silver Sponsor",
    technicalSponsorTitle: "Technical Sponsor",
    technicalPartnerTitle: "Technical Partner",
    culturalSponsorTitle: "Cultural Sponsor",
    financialSponsorTitle: "Sponsor",
    successPartnersTitle: "Success Partners",
    eventPartnersTitle: "Event Partners",
    partnersOfTheDayTitle: "Partners of this Day",
    partnersOfTheDayDescription: "Thanks to the entities that chose to be part of this work, the ceremony is complete and its impact is strengthened. Here you will find the entities contributing to organizing the 'Year of Victory' events in various states.",
    becomePartnerTitle: "Be a partner with us on this day",
    becomePartnerSubtitle: "Contribute to the success of the Year of Victory event in your state or through your entity.",
    becomePartnerButton: "Apply for partnership"
  },
  tr: {
    whoAreWeTitle: "Biz kimiz",
    organizersTitle: "Organizatörler",
    sponsorsTitle: "Sponsorlar",
    strategicSponsorTitle: "Stratejik Sponsor",
    diamondSponsorTitle: "Elmas Sponsor",
    goldSponsorTitle: "Altın Sponsor",
    silverSponsorTitle: "Gümüş Sponsor",
    technicalSponsorTitle: "Teknik Sponsor",
    technicalPartnerTitle: "Teknik Ortak",
    culturalSponsorTitle: "Kültürel Sponsor",
    financialSponsorTitle: "Sponsor",
    successPartnersTitle: "Başarı Ortakları",
    eventPartnersTitle: "Etkinlik Ortakları",
    partnersOfTheDayTitle: "Bu Günün Ortakları",
    partnersOfTheDayDescription: "Bu çalışmanın bir parçası olmayı seçen kurumlar sayesinde tören tamamlanıyor ve etkisi güçleniyor. Burada çeşitli illerde 'Zafer Yılı' etkinliklerinin düzenlenmesine katkıda bulunan kurumları bulabilirsiniz.",
    becomePartnerTitle: "Bu günde bizimle ortak olun",
    becomePartnerSubtitle: "Bulunduğunuz ilde veya kurumunuz aracılığıyla Zafer Yılı etkinliğinin başarısına katkıda bulunun.",
    becomePartnerButton: "Ortaklık başvurusunda bulunun"
  }
};

